/*
 * Odelle-Produktreihen (Produktseite): „Ähnliche Produkte“ und „Zuletzt angesehen“ im Nelly-Stil.
 * Sucht alle [data-odelle-reihe], lädt die Produkte und baut die Karten.
 * - aehnlich: /recommendations/products.json?product_id=…&intent=related
 * - zuletzt:  Handles aus localStorage „odelle-zuletzt“ (ohne das aktuelle Produkt)
 * Zum Ansehen ohne weitere Produkte: ?reihe-test an die Adresse hängen (zeigt das aktuelle Produkt mehrfach).
 */
(function () {
  var FARBEN = {
    khaki: '#cdbb98', beige: '#d9c8ae', creme: '#efe6d6', 'weiß': '#ffffff', weiss: '#ffffff',
    braun: '#3f2b20', hellbraun: '#8a6a4f', dunkelbraun: '#2e2019', schwarz: '#141110',
    grau: '#9a9894', hellgrau: '#cfcdc9', dunkelgrau: '#55524e', blau: '#45607f', hellblau: '#b4c8de',
    dunkelblau: '#1f2a44', rosa: '#e6bcc0', rot: '#a8261f', weinrot: '#6b1f2a', 'grün': '#4b6650',
    'olivgrün': '#6b6a3f', gelb: '#e6cd72', orange: '#d6823a', lila: '#8a6aa6', gold: '#c9a96a', silber: '#c4c4c4',
    aprikose: '#efc6a4', champagner: '#e8d7b4', flieder: '#c3b3d9', fuchsia: '#c2367a', hellgelb: '#f2e3a1', hellrosa: '#f1d3d5', ingwer: '#b5652b', kamel: '#b8895a', minze: '#b9dcc8', pink: '#d9467a', blaubraun: '#5b5550', avocado: '#8a9a4b', 'hellgrün': '#b7d39a', mokka: '#5a3e2f', dunkelviolett: '#4b2e5a', melonenrot: '#e8505b', 'rosa-blau': '#b9a7cf'
  };
  var preis = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var test = /[?&]reihe-test\b/.test(location.search);

  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function bild(src, breite) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }
  function farbWerte(p) {
    var o = (p.options || []).find(function (x) { return (x.name || x) === 'Farbe'; });
    return o && o.values ? o.values : [];
  }

  function karte(p, marke) {
    var bilder = (p.images || []).map(function (i) { return typeof i === 'object' ? (i.src || i.url) : i; });
    var b1 = bild(p.featured_image || bilder[0], 700);
    var b2 = bilder[1] ? bild(bilder[1], 700) : '';
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var schilder = [];
    if (!p.available) schilder.push('<span class="odelle-reihe__schild odelle-reihe__schild--dunkel">Ausverkauft</span>');
    else if (p.compare_at_price && p.compare_at_price > p.price) schilder.push('<span class="odelle-reihe__schild odelle-reihe__schild--dunkel">Sale</span>');
    if (tags.indexOf('neu') > -1) schilder.push('<span class="odelle-reihe__schild">Neu</span>');
    var farben = farbWerte(p);
    var farbHtml = '';
    if (farben.length) {
      farbHtml = '<div class="odelle-reihe__farben" aria-label="Farben: ' + esc(farben.join(', ')) + '">' +
        farben.slice(0, 4).map(function (f) {
          var hex = FARBEN[String(f).toLowerCase()] || '#e6e6e6';
          return '<span class="odelle-reihe__farbe" style="background:' + hex + '" title="' + esc(f) + '"></span>';
        }).join('') + (farben.length > 4 ? '<span>+' + (farben.length - 4) + '</span>' : '') + '</div>';
    }
    var preisHtml = esc(preis.format(p.price / 100));
    if (p.compare_at_price && p.compare_at_price > p.price) preisHtml += '<s>' + esc(preis.format(p.compare_at_price / 100)) + '</s>';
    return '<div class="odelle-reihe__karte">' +
      '<a class="odelle-reihe__link" href="' + esc(p.url || ('/products/' + p.handle)) + '">' +
        '<div class="odelle-reihe__bild">' +
          (b1 ? '<img src="' + esc(b1) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          (b2 ? '<img src="' + esc(b2) + '" alt="" loading="lazy" aria-hidden="true">' : '') +
          (schilder.length ? '<div class="odelle-reihe__schilder">' + schilder.join('') + '</div>' : '') +
        '</div>' +
        '<div class="odelle-reihe__info">' +
          (marke ? '<p class="odelle-reihe__marke">' + esc(marke) + '</p>' : '') +
          '<p class="odelle-reihe__name">' + esc(p.title) + '</p>' +
          '<p class="odelle-reihe__preis">' + preisHtml + '</p>' +
          farbHtml +
        '</div>' +
      '</a>' +
      '<button type="button" class="odelle-merken odelle-merken--karte" data-odelle-merken="' + esc(p.handle) + '" aria-pressed="false" aria-label="Auf die Merkliste">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 6.9 4.5c2.1 0 3.6 1.2 5.1 3 1.5-1.8 3-3 5.1-3 3.5 0 5.5 3.5 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>' +
      '</button>' +
    '</div>';
  }

  function holen(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function laden(box) {
    var art = box.getAttribute('data-odelle-reihe');
    var id = box.getAttribute('data-produkt-id');
    var handle = box.getAttribute('data-produkt-handle');
    var anzahl = parseInt(box.getAttribute('data-anzahl'), 10) || 10;
    if (art === 'zuletzt') {
      var liste = [];
      try { liste = JSON.parse(localStorage.getItem('odelle-zuletzt') || '[]'); } catch (e) {}
      if (!Array.isArray(liste)) liste = [];
      liste = liste.filter(function (h) { return test || h !== handle; }).slice(0, anzahl);
      if (test && liste.length < 4 && handle) while (liste.length < 4) liste.push(handle);
      return Promise.all(liste.map(holen)).then(function (l) { return l.filter(Boolean); });
    }
    if (!id) return Promise.resolve([]);
    return fetch('/recommendations/products.json?product_id=' + id + '&limit=' + anzahl + '&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; })
      .then(function (l) {
        if (test && l.length < 4 && handle) {
          return holen(handle).then(function (p) { var t = l.slice(); while (p && t.length < 5) t.push(p); return t; });
        }
        return l;
      });
  }

  function pfeile(box) {
    var spur = box.querySelector('[data-spur]');
    var knoepfe = box.querySelectorAll('.odelle-reihe__pfeil');
    function stand() {
      var max = spur.scrollWidth - spur.clientWidth - 2;
      knoepfe.forEach(function (k) {
        k.disabled = k.getAttribute('data-richtung') === '-1' ? spur.scrollLeft <= 2 : spur.scrollLeft >= max;
      });
      box.querySelector('.odelle-reihe__pfeile').style.visibility = max > 0 ? '' : 'hidden';
    }
    knoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        var start = spur.scrollLeft;
        var ziel = start + parseInt(k.getAttribute('data-richtung'), 10) * spur.clientWidth * 0.9;
        spur.scrollTo({ left: ziel, behavior: 'smooth' });
        // Absicherung: manche Browser animieren nicht (Einrasten der Karten) – dann direkt springen
        setTimeout(function () {
          if (Math.abs(spur.scrollLeft - start) < 2) spur.scrollTo({ left: ziel, behavior: 'instant' });
          stand();
        }, 400);
      });
    });
    spur.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand);
    stand();
  }

  function start() {
    document.querySelectorAll('[data-odelle-reihe]').forEach(function (box) {
      if (box.dataset.geladen) return;
      box.dataset.geladen = '1';
      laden(box).then(function (produkte) {
        if (!produkte.length) return;
        box.querySelector('[data-spur]').innerHTML = produkte.map(function (p) { return karte(p, box.getAttribute('data-marke')); }).join('');
        box.hidden = false;
        pfeile(box);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
